// @flow
import React, { Component, Fragment } from "react";

import { AppbarMenu, AppbarMenuGroup } from "imagus-components";
import { NavList, AdminList, DocList, LegalItem } from "./NavList";
import AuthedAppbarMenuItem from "../components/AuthedAppbarMenuItem";
import UserAuth from "../containers/UserAuth";
import Terms from "../../account/components/Terms";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import LogoImage from "../../../images/logo.svg";

type MobileMenuPropsType = {};

type MobileMenuStatesType = {
  drawerOpen: boolean,
  termsOpen: boolean
};

class MobileMenu extends Component<MobileMenuPropsType, MobileMenuStatesType> {
  constructor(props: MobileMenuPropsType) {
    super(props);
    this.state = {
      drawerOpen: false,
      termsOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ termsOpen: status });
  };

  toggleDrawer = (open: boolean): * => {
    this.setState({
      drawerOpen: open
    });
  };

  handleClick = (onClick: Function | null): * => {
    if (onClick) {
      onClick();
    } else {
      this.toggleDrawer(false);
    }
  };

  render(): React$Element<*> {
    return (
      <UserAuth principal="user" unAuthChildren={<RedirectoLogin />}>
        <AppbarMenu
          logo={LogoImage}
          title="Vix Vizion"
          open={this.state.drawerOpen}
          toggleDrawer={this.toggleDrawer}
          menus={
            <Fragment>
              <Terms
                open={this.state.termsOpen}
                handleModalStatus={this.switchModalStatus}
              />
              <AppbarMenuGroup
                subHeader="Imagus"
                subLists={NavList.map(
                  (nav: *, i: number): * => (
                    <AuthedAppbarMenuItem
                      key={"user" + i}
                      auth={nav.auth}
                      to={nav.to}
                      text={nav.text}
                      icon={nav.icon}
                      onClick={(): * => this.handleClick(nav.onClick)}
                    />
                  )
                )}
              />

              <UserAuth principal="imagus_admin">
                <AppbarMenuGroup
                  subHeader="Admin"
                  subLists={AdminList.map(
                    (nav: *, i: number): * => (
                      <AuthedAppbarMenuItem
                        key={"admin" + i}
                        auth={nav.auth}
                        to={nav.to}
                        text={nav.text}
                        icon={nav.icon}
                        onClick={(): * => this.handleClick(nav.onClick)}
                      />
                    )
                  )}
                />
              </UserAuth>

              <UserAuth principal="user">
                <AppbarMenuGroup
                  subHeader="Legal"
                  subLists={
                    <AuthedAppbarMenuItem
                      key={"legal-item"}
                      auth={LegalItem.auth}
                      text={LegalItem.text}
                      icon={LegalItem.icon}
                      onClick={(): * => this.switchModalStatus(true)}
                    />
                  }
                />
              </UserAuth>

              <UserAuth principal="user">
                <AppbarMenuGroup
                  subHeader="Document"
                  subLists={DocList.map(
                    (nav: *, i: number): * => (
                      <AuthedAppbarMenuItem
                        key={"doc" + i}
                        auth={nav.auth}
                        to={nav.to}
                        text={nav.text}
                        icon={nav.icon}
                        onClick={(): * => this.handleClick(nav.onClick)}
                      />
                    )
                  )}
                />
              </UserAuth>
            </Fragment>
          }
        />
      </UserAuth>
    );
  }
}

export default MobileMenu;
